export const GPS_ALTITUDE_KEY = '_gps_altitude';

export interface ChannelConfig {
  key: string;
  label: string;
  unit: string;
  color: string;
  transform: (rawValue: number) => number;
  decimals: number;
}

export const SENSOR_CHANNELS: Record<string, ChannelConfig> = {
  [GPS_ALTITUDE_KEY]: {
    key: GPS_ALTITUDE_KEY,
    label: 'Flughöhe (GNSS)',
    unit: 'm',
    color: '#3b82f6',
    transform: (val: number) => val,
    decimals: 0,
  },
  temperature: {
    key: 'temperature',
    label: 'Temperatur',
    unit: '°C',
    color: '#c0392b',
    transform: (val: number) => val,
    decimals: 2,
  },
  relativeHumidity: {
    key: 'relativeHumidity',
    label: 'Rel. Luftfeuchtigkeit',
    unit: '%',
    color: '#2980b9',
    transform: (val: number) => val,
    decimals: 1,
  },
  pressure: {
    key: 'pressure',
    label: 'Luftdruck',
    unit: 'hPa',
    color: '#f1c40f',
    transform: (val: number) => val,
    decimals: 1,
  },
  acceleration: {
    key: 'acceleration',
    label: 'Beschleunigung',
    unit: 'g',
    color: '#e74c3c',
    transform: (val: number) => val,
    decimals: 2,
  },
  trueAirSpeed: {
    key: 'trueAirSpeed',
    label: 'Fluggeschwindigkeit (TAS)',
    unit: 'km/h',
    color: '#27ae60',
    transform: (ms: number) => ms * 3.6, // Convert m/s -> km/h
    decimals: 1,
  },
  batteryLevel: {
    key: 'batteryLevel',
    label: 'Akkustand',
    unit: '%',
    color: '#16a085',
    transform: (val: number) => val,
    decimals: 1,
  },
};

export function getChannelConfig(channel: string): ChannelConfig {
  return (
    SENSOR_CHANNELS[channel] ?? {
      key: channel,
      label: channel.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase()),
      unit: '',
      color: '#4a90d9',
      transform: (val: number) => val,
      decimals: 2,
    }
  );
}

export function transformChannelValue(
  channel: string,
  rawValue: number | undefined | null
): number | undefined {
  if (rawValue === undefined || rawValue === null || isNaN(rawValue)) return undefined;
  const config = getChannelConfig(channel);
  return config.transform(rawValue);
}

export function formatChannelValue(
  channel: string,
  rawValue: number | undefined | null
): string {
  const transformed = transformChannelValue(channel, rawValue);
  if (transformed === undefined) return '–';
  const config = getChannelConfig(channel);
  return transformed.toFixed(config.decimals);
}
